import React from "react";
import { connect } from "react-redux";
import CardWrapper from "../../CardWrapper";
import { getLOVDGeneData } from "../../../../state/selectors/Lovd.selectors";
import { formatModeofInheritance } from "../../../OMIM/helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import LovdGeneType from "../../../componentTypes/LovdGeneType";

const GeneLOVDCard = React.memo(({ card, data }) => {
  const isDisabled = !Object.keys(data || {}).length;

  const countTermsOccurrences = () => {
    if (data && data?.phenotypes && data?.phenotypes?.length > 0) {
      const terms = data.phenotypes
        .map((e) => e?.inheritance_pattern?.term)
        .filter(Boolean)
        .flat();
      const occurrences = terms.reduce((acc, curr) => {
        // eslint-disable-next-line
          return (acc[curr] = (acc[curr] || 0) + 1), acc;
      }, {});
      return occurrences;
    }
    return [];
  };

  const countPhenotypes = () => {
    const count = (data && data?.phenotypes && data?.phenotypes?.length) || 0;
    return count;
  };

  const termsOfInheritance = countTermsOccurrences();
  const numberOfPhenotypes = countPhenotypes();
  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      color={
        numberOfPhenotypes === 0
          ? getPathogenicityColorByAllNames("B")
          : getPathogenicityColorByAllNames("P")
      }
    >
      <>
        {numberOfPhenotypes > 0 ? (
          <div data-testid="numberOfPhenotypes">
            {"Phenotypes: "}
            <b data-testid="phenotypesValue">{numberOfPhenotypes}</b>
          </div>
        ) : null}
      </>
      <>
        {termsOfInheritance && Object.keys(termsOfInheritance).length > 0 && (
          <div data-testid="termsOfInheritance">
            {Object.entries(termsOfInheritance).map(([key, val], i) => {
              return (
                <span key={i}>
                  {`${formatModeofInheritance(key)}: `}
                  <b>
                    <span>{val}</span>
                    {i === Object.entries(termsOfInheritance).length - 1
                      ? null
                      : ", "}
                  </b>
                </span>
              );
            })}
          </div>
        )}
      </>
    </CardWrapper>
  );
});

GeneLOVDCard.propTypes = LovdGeneType;

GeneLOVDCard.defaultProps = {
  data: {},
};

const mapStateToProps = (state) => ({
  data: getLOVDGeneData(state),
});

export default connect(mapStateToProps)(GeneLOVDCard);
